export default function () {
  const page = document.querySelector('.PageMain--work-with-us')

  if (page) {
    const buttons = Array.from(
      page.querySelectorAll('.wp-block-button .wp-block-button__link')
    )

    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        const elementHash = this.hash ? document.querySelector(this.hash) : null

        if (elementHash) {
          e.preventDefault()

          const scrollPosition = elementHash.offsetTop

          window.scrollTo({
            top: scrollPosition,
            left: 0,
            behavior: 'smooth',
          })
        }
      })
    })

    const animatedBlocks = Array.from(page.querySelectorAll('.AnimatedBlock'))

    window.addEventListener('scroll', watchScroll)
    watchScroll()

    function watchScroll() {
      let timer = 50

      animatedBlocks.forEach(function (block) {
        if (isInViewport(block) && !block.shown) {
          setTimeout(() => {
            block.shown = true
            block.classList.add('AnimatedBlock--actived')
          }, timer)

          timer += 50
        }
      })
    }

    function isInViewport(el) {
      const rect = el.getBoundingClientRect()
      return (
        (rect.top >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight)) ||
        (rect.top < 0 && rect.bottom > 0)
      )
    }
  }
}
